import { FaCircleCheck } from "react-icons/fa6"
import { useNavigate } from "react-router-dom";
import {
  Box,
  Center,
  VStack,
} from "@chakra-ui/react"
import { Button, Text } from "@/components"
import { useViewer } from "@/contexts"
import { ComplianceType } from "@/types"

interface Props {
  complianceType: ComplianceType
  onNavigateToDocuments?: () => void
}

export const CompletedTaskComponent = ({ complianceType, onNavigateToDocuments }: Props) => {
  const navigate = useNavigate()
  const { viewedClient } = useViewer()

  const handleGoToDocuments = () => {
    if (onNavigateToDocuments) {
      onNavigateToDocuments()
    } else {
      navigate(viewedClient ? `/clients/${viewedClient.id}` : "/documents")
    }
  }
  return (
    <Center w="100%" h="100%">
      <VStack
        position="relative"
        zIndex={1}
        w={{ base: "92%", md: "40%" }}
        p={5}
        borderRadius={10}
        bg="white"
        boxShadow="md"
        mt={20}
      >
        <Box borderRadius={5} bg="green.300" p={3}>
          <FaCircleCheck size={30} color="white" />
        </Box>
        <Text fontSize="lg" fontWeight="bold" textAlign="center" mt={2} mb={2}>
          {`${complianceType} completed!`}
        </Text>
        <Text fontSize="sm" textAlign="center" mb={5}>
          {`Thank you for signing our ${complianceType}. If you would like to download the signed copy please go to the Documents Page.`}
        </Text>
        {
          complianceType === ComplianceType.BACKGROUND_CHECK && (
            <Text fontSize="sm" textAlign="center" mb={5}>
              Note that this form cannot be accepted unless it has your full legal name (including middle names), SSN, your current home address (no PO box), and birthdate. Also, be sure to lift any security freeze on your credit file (all three bureaus) for at least a day so we can run the report. After the credit check, you might receive unsolicited financing offers from third parties. Please note that this is due to credit bureau marketing efforts, and not because ESO has shared your information. To avoid this, opt out of the credit bureau marketing efforts by visiting OptOutPreScreen.com or calling 1-888-OPT-OUT (1-888-567-8688).
            </Text>
          )
        }
        <Button variant="solid" onClick={handleGoToDocuments}>Go To Documents</Button>
      </VStack>
    </Center>
  )
}